<template>
  <div v-if="orderDetails" class="tw-p-5">
    <h1 class="tw-text-xl md:tw-text-3xl tw-flex tw-items-center tw-mt-12 tw-text-infinity-highlight page-title tw-mb-0">{{ pageTitle }} <span
        v-if="orderStatus" :class="orderStatus.style"
        class="tw-font-light tw-rounded-full tw-px-2 tw-py-1 tw-mr-4 tw-text-sm tw-ml-2">{{orderStatus.label}}</span></h1>
    <p class="tw-mt-2 tw-mb-8 tw-text-infinity-primary-text">{{ convertedDate }}</p>
    <div
      class="tw-py-7 tw-border-solid tw-border-0 tw-border-b tw-border-infinity-highlight-faded tw-flex tw-items-start">
      <div>
        <img :src="sellerArtwork" height="50px" />
      </div>
      <a :href="receiptUrl" target="_blank" class="tw-mr-0 tw-ml-auto c-button c-button--default c-button--shrinked">
        <font-awesome-icon icon="download" class="tw-mr-2" />
        <span>Download Receipt</span>
      </a>
    </div>
    <div class="tw-pb-8 tw-border-solid tw-border-0 tw-border-b tw-border-infinity-highlight-faded">
      <table class="w-full">
        <thead class="bg-gray-100">
          <tr>
            <th colspan="2" class="tw-text-infinity-highlight tw-text-base tw-pb-4 tw-pt-8">Customer Information</th>
          </tr>
        </thead>
        <tbody class="tw-hidden md:tw-table-row-group">
          <tr class="bg-white">
            <td><strong>Full Name</strong></td>
            <td><strong>Email</strong></td>
          </tr>
          <tr class="bg-white">
            <td>{{ orderDetails.customer.name }}</td>
            <td>{{ orderDetails.customer.email }}</td>
          </tr>
          <tr>
            <th colspan="2" class="tw-text-infinity-highlight tw-text-base tw-pb-4 tw-pt-8">Seller Information</th>
          </tr>
          <tr class="bg-white">
            <td><strong>Full Name</strong></td>
            <td><strong>Email</strong></td>
          </tr>
          <tr class="bg-white">
            <td>{{ sellerInformation.name }}</td>
            <td>{{ sellerInformation.email }}</td>
          </tr>
        </tbody>
        <tbody class="tw-table-row-group md:tw-hidden">
          <tr class="bg-white">
            <td colspan="2"><strong>Full Name</strong></td>
          </tr>
          <tr class="bg-white">
            <td colspan="2">{{ orderDetails.customer.name }}</td>
          </tr>
          <tr class="bg-white">
            <td colspan="2" class="tw-pt-2"><strong>Email</strong></td>
          </tr>
          <tr class="bg-white">
            <td colspan="2">{{ orderDetails.customer.email }}</td>
          </tr>
          <tr>
            <th colspan="2" class="tw-text-infinity-highlight tw-text-base tw-pb-4 tw-pt-8">Seller Information</th>
          </tr>
          <tr class="bg-white">
            <td colspan="2" class="border"><strong>Full Name</strong></td>
          </tr>
          <tr class="bg-white">
            <td colspan="2" class="border">{{ sellerInformation.name }}</td>
          </tr>
          <tr class="bg-white">
            <td colspan="2" class="tw-pt-2"><strong>Email</strong></td>
          </tr>
          <tr class="bg-white">
            <td colspan="2" class="border">{{ sellerInformation.email }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <transaction-details :items="orderDetails.items" :total="totalPriceDetails"></transaction-details>
    <h1 class="tw-text-infinity-highlight tw-text-base tw-pb-4 tw-pt-8">Items</h1>
    <order-details-items v-if="formatItems" v-for="item in formatItems" :beat="item[0]" :item="item[1]" :contract-download-url="item.contractDownloadUrl"
      :key="item.itemId"></order-details-items>
  </div>
  <div v-else class="loading-wrapper">
    <font-awesome-icon icon="spinner-third" spin size="2x"></font-awesome-icon>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import orderDetailsItems from './order-details-items.vue'
import Beat from '../../models/beat'
import Song from '../../models/song'
import SoundKit from '../../models/soundkit'
import Collection from '../../models/collection'
import transactionDetails from './order-details-transaction-details.vue'
import Service from "../../models/service";
import ServiceQuote from "../../models/ServiceQuote";

export default {
  name: 'order-details',
  components: {
    orderDetailsItems,
    transactionDetails
  },
  data () {
    return {
      loading: false,
      orderDetails: null,
      downloadingReceipt: false
    }
  },
  computed: {
    totalPriceDetails() {
      return {
        total: this.orderDetails.order_total?.amount,
        subTotal: this.orderDetails.initial_total?.amount ,
        discount: this.orderDetails.total_discount?.amount
      }
    },
    receiptUrl() {
      if(!this.orderDetails) return
      return this.orderDetails.receipt_url
    },
    orderStatus () {
      if (!this.orderDetails.order_status) return
      if (this.orderDetails.order_status === 1)
        return {
          label: 'complete', style: 'tw-bg-infinity-success-faded tw-text-infinity-success'
        }

      if (this.orderDetails.order_status === 0)
        return {
          label: 'pending', style: 'tw-bg-infinity-success-faded tw-text-infinity-success'
        }

      if (this.orderDetails.order_status === -1)
        return { label: 'failed', style: 'tw-bg-infinity-success-faded tw-text-infinity-success' }
      return
    },
    convertedDate () {
      const date = dayjs(this.orderCreationDate).locale('en');
      const formattedDate = date.format('MMM DD, YYYY dddd, h:mm A') + ' EST';
      return formattedDate;
    },
    sellerInformation () {
      return { email: ab.user.email, name: ab.user.name }
    },
    formatItems () {
      const items = []
      for (const item of this.orderDetails.items) {
          if(item.saleable_type !== undefined) {
            switch(item.saleable_type) {
              case 'beat':
                items.push([new Beat(item),  item])
                break;
              case 'song':
                items.push([new Song(item),  item])
                break;
              case 'soundkit':
                items.push([new SoundKit(item),item])
                break;
              case 'beattapes':
                items.push([Collection.make(item),item])
                break;
              case 'service':
                items.push([new Service(item),item])
                break;
              case 'service_quote':
                items.push([new ServiceQuote(item),item])
                break;
            }
        }
      }
      return items
    },
    sellerArtwork () {
      return ab.config.logo;
    },
    orderCreationDate () {
      return this.orderDetails ? this.orderDetails.created_at : '';
    },
    pageTitle () {
      return this.orderDetails ? `Order IS-${this.orderDetails?.order_number}` : ``
    },
    user () {
      return this.$store.state.user;
    },
    loggedInUser () {
      if (!this.$store.state.loggedInUser) {
        this.orders = null
      }
      return this.$store.state.loggedInUser
    }
  },
  methods: {
    getOrderDetails () {
      this.loading = true
      if (!this.user) return
      const orderId = this.$route.params.orderId
      this.$http.get(`${ab.apiUrl}/orders/${orderId}`, {
        params: {
          'api_token': this.loggedInUser.token
        }
      }).then((response) => {
        this.loading = false
        this.orderDetails = response.data;
      }).catch(() => {
        this.loading = false
      })

    }
  },
  mounted () {
    this.getOrderDetails()
  },
  watch: {
    user (val) {
      if (val) this.getOrderDetails();
    }
  }
}
</script>
<style>
.loading-wrapper {
    text-align: center;
    padding: 20px 0;
}
</style>
